import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAccessTokenValid } from "../../utils/validateToken";
import "../../styles/dashboardProfile.css";

const DashboardProfile = () => {
	const { role, firstname, lastname, address, id, gender } = useSelector((state) => state.auth);
	const accessToken = localStorage.getItem("accessToken");
	const isValidToken = isAccessTokenValid(accessToken);
	const navigate = useNavigate();

	useEffect(() => {
		isValidToken ? navigate("/dashboard") : navigate("/signin");
	}, []);

	return (
		<>
			<h2 className="sub_title">Profile Info</h2>
			<p className="profile_greet"> Hello, {firstname}</p>
			<div className="profile_details">
				<p>Name: {firstname} {lastname}</p>
				<p>Role: {role}</p>
				<p>ID: {id}</p>
				<p>Gender: {gender}</p>
				<p>Address: {address}</p>
				<p>Token: &nbsp;
					<span>
						{`${accessToken?.substring(0,	15)}
						 . . . 
						 ${accessToken?.substring(accessToken.length - 8)}`}
					</span>
				</p>
				<br />
				<h4>About the author</h4>
				<p>
					I’m a simple and a bit timid person, passionate in Web
					Development and 3d Technologies. I aim to refine my skills, learn
					new techniques, and deliver the best results.
				</p>
			</div>
		</>
	);
};

export default DashboardProfile;
